function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
/**
 * Extracts props from an object and returns the remainingg props as another
 * object. The difference between using this and object rest spread is this
 * will not copy over properties that are `undefined`.
 */

export function extractProps(obj, keys) {
  var withKeys = {};
  var withoutKeys = {};
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];

    if (value !== undefined) {
      if (keys.indexOf(key) === -1) {
        withoutKeys[key] = value;
      } else {
        withKeys[key] = value;
      }
    }
  });
  return [withKeys, withoutKeys];
}
export function extractStyledSystemProps(obj, styledConfigs) {
  if (!Array.isArray(styledConfigs)) {
    // eslint-disable-next-line no-param-reassign
    styledConfigs = [styledConfigs];
  }

  var keys = styledConfigs.reduce(function (keysMemo, styledConfig) {
    return [].concat(keysMemo, Object.keys(styledConfig.config || styledConfig));
  }, []);
  return extractProps(obj, keys);
}
/**
 * Compose multiple ref functions into a single ref function.
 *
 *     <Button ref={composeRefs([getTriggerRef, getResizerRef])} />
 */

export function composeRefs(refFns) {
  return function (ref) {
    return refFns.forEach(function (refFn) {
      return refFn && refFn(ref);
    });
  };
}
/**
 * Shortcut for forwarded a ref to the `innerRef` prop.
 */

export function forwardInnerRef(SourceComponent) {
  return React.forwardRef(function (props, ref) {
    return React.createElement(SourceComponent, _extends({
      innerRef: ref
    }, props));
  });
}